// removed by extract-text-webpack-plugin
module.exports = {"root":"EnterpriseTable__root___3y2xR"};


//////////////////
// WEBPACK FOOTER
// ./src/components/enterprise/EnterpriseTable/EnterpriseTable.scss
// module id = 1026
// module chunks = 0